import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
  },
  {
    path: 'results',
    loadComponent: () => import('./pages/results/results.component').then((m) => m.ResultsComponent),
  },
  {
    path: 'create-hotel',
    loadComponent: () => import('./pages/create-hotel/create-hotel.component').then((m) => m.CreateHotelComponent),
  },
  {
    path: 'app-ready',
    loadComponent: () => import('./pages/app-ready/app-ready.component').then((m) => m.AppReadyComponent),
  },
  {
    path: 'try-assistant',
    loadComponent: () => import('./pages/try-assistant/try-assistant.component').then((m) => m.TryAssistantComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
